import InlineComponent from './inlineComponent.jsx';
import RVCTextbox from '../../../components/output_textbox/RVCTextbox.jsx';

module.exports = class OutputRenderer extends InlineComponent {
  define() {
    this.component = RVCTextbox;
    this.data = {
      logUrl: this.element.data('logurl'),
      hostname: this.element.data('hostname'),
      update_channel: this.element.data('updatechannel'),
    };
  }
};
